import React from 'react';
import { Container, Link } from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const TopMenu = () => {
  const pages = [{ to: '/', label: 'Информация о сделках' }];

  const navigate = useNavigate();
  const location = useLocation();
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleRouteLink = (to: string) => {
    handleCloseNavMenu();
    navigate(to);
  };

  const pagesFiltered = pages.filter((v) => v.to !== location.pathname);

  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          display: {
            xs: 'inline-flex',
            sm: 'none',
          },
        }}
      >
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleOpenNavMenu}
          color="inherit"
        >
          <MenuIcon />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorElNav}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={Boolean(anchorElNav)}
          onClose={handleCloseNavMenu}
          sx={{
            display: {
              xs: 'block',
              md: 'none',
            },
          }}
        >
          {pagesFiltered.map((page) => (
            <MenuItem key={page.label} onClick={() => handleRouteLink(page.to)}>
              <Typography textAlign="center">{page.label}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: {
            xs: 'none',
            sm: 'flex',
          },
        }}
      >
        {pagesFiltered.map((page) => (
          <Link component={RouterLink} to={page.to} key={page.label}>
            <Typography
              sx={{
                textDecoration: 'underline',
                mr: 3,
                my: 3,
              }}
            >
              {page.label}
            </Typography>
          </Link>
        ))}
      </Box>
    </Container>
  );
};

export default TopMenu;
